import Spellcheck from '@mui/icons-material/Spellcheck';

import { EditOrderApproval } from './EditOrderApproval';
import { CreateOrderApproval } from './CreateOrderApproval';

import ApprovalList from './ApprovalList';

export default {
      list: ApprovalList,
      edit: EditOrderApproval,
      create: CreateOrderApproval,
      icon: Spellcheck,
}